import React, { Component } from 'react'
import { AuthStorage } from '@/storage/index'
import { connect } from 'react-redux'
import { CoreContext } from '@/contexts/core'
import { withAuthConsumer } from '@/hocs/withAuthConsumer'
import { MagazineLoader } from '@/components/commons/LoaderComponent'

class checkAuth extends Component {
  doLoginToken = () => {
    const { token, lang, officeToken } = this.props.match.params
    const hasAlreadyAuth = JSON.parse( AuthStorage.getValue() )

    const langs = {
      br: 'pt_br',
      us: 'en_us',
      it: 'it_it',
      es: 'es_es',
      fr: 'fr_fr',
      de: 'de_de'
    }
    const language = langs[lang]

    if ( hasAlreadyAuth ) {
      AuthStorage.deleteValue()
    }
    this.props.authConsumer.doToken( token )
    this.setLanguage( language )

    localStorage.setItem( '__office_token__' , officeToken )
  }

  /**
   * SET DEFAULT OFFICE LANGUAGE
   */
  setLanguage = async code => {
    const lang = await code
    this.context.changeLanguage( lang )
  }

  loaderLogin = () => {
    this.doLoginToken()
    return <MagazineLoader />
  }

  render () {
    return this.loaderLogin()
  }
}
checkAuth.contextType = CoreContext.Consumer
export default connect()( withAuthConsumer( checkAuth ) )



// WEBPACK FOOTER //
// ./src/components/auth/checkAuth/checkAuth.js